import { render } from "./VisualPopups.vue?vue&type=template&id=8b61816e"
import script from "./VisualPopups.vue?vue&type=script&lang=js"
export * from "./VisualPopups.vue?vue&type=script&lang=js"

import "./VisualPopups.vue?vue&type=style&index=0&id=8b61816e&lang=scss"
script.render = render

export default script